export default "__VITE_ASSET__C4DhWP28__"